import type { ComponentType } from "react";

import type { NavMegaMenuPreviewKey } from "../nav-mega-menu-data";
import { CompanyAboutNavPreview } from "./company-about-preview";
import { CompanyCareersNavPreview } from "./company-careers-preview";
import { CompanyPartnersNavPreview } from "./company-partners-preview";
import { ResourcesBlogNavPreview } from "./resources-blog-preview";
import { ResourcesEventsNavPreview } from "./resources-events-preview";
import { ResourcesInsightsNavPreview } from "./resources-insights-preview";
import { ResourcesToolsNavPreview } from "./resources-tools-preview";

const REACT_PREVIEWS: Partial<Record<NavMegaMenuPreviewKey, ComponentType>> = {
  "company-about": CompanyAboutNavPreview,
  "company-careers": CompanyCareersNavPreview,
  "company-partners": CompanyPartnersNavPreview,
  "resources-blog": ResourcesBlogNavPreview,
  "resources-insights": ResourcesInsightsNavPreview,
  "resources-events": ResourcesEventsNavPreview,
  "resources-tools": ResourcesToolsNavPreview,
};

export function NavMegaMenuPreview({
  previewKey,
}: {
  previewKey: NavMegaMenuPreviewKey;
}) {
  const Preview = REACT_PREVIEWS[previewKey];
  if (Preview) return <Preview />;
  return null;
}

export function isReactNavPreview(previewKey: NavMegaMenuPreviewKey) {
  return previewKey in REACT_PREVIEWS;
}
